<template>
  <div>
    <el-dialog v-dialogDrag :visible.sync="childDialogVisible" :title="'选择'+$titles.child" width="600px" :close-on-click-modal="false"
      :close-on-press-escape="false" @closed="close">
      <div style="margin:10px 0px;display: flex;justify-content: space-between;">
        <el-input v-model="searchValue" :placeholder="'输入'+$titles.child+'名称/编号搜索'" size="small" @keyup.enter.native="search" />
      </div>
      <div class="addTitle">选择现有的{{ $titles.child }}</div>
      <el-table ref="multipleTable"
        :key="tabKey"
        :data="searchList"
        tooltip-effect="dark" style="width: 100%;min-height:300px" height="calc(100% - 70px)" row-key="childId"
        border @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="49" align="center" reserve-selection />
        <el-table-column prop="childName" :label="$titles.child+'名称'" align="left" />
        <el-table-column prop="childNo" :label="$titles.child+'编号'" align="left" />
        <el-table-column label="操作" width="120" align="center">
          <template #default="{ row }">
            <el-button size="small" type="text" @click="handleDeleteChild(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="addTitle">
        没有要选择的{{ $titles.child }}？
        <el-button v-if="!showAddingForm" type="text" size="small" @click="showAddingForm = true">+新增{{ $titles.child }}</el-button>
        <el-button v-if="showAddingForm" type="text" icon="el-icon-check" size="small" @click="handleAddChild">提交</el-button>
        <el-button v-if="showAddingForm" type="text" icon="el-icon-close" size="small" @click="close">
          取消
        </el-button>
      </div>
      <el-form v-if="showAddingForm" ref="addingForm" :model="addingForm" label-position="left" label-width="80px" size="small">
        <el-form-item :label="$titles.child+'名称'" :rules="{ required: true, message: ' ' }">
          <el-input ref="childName" v-model="addingForm.childName" placeholder="必填" maxlength="30"
            :show-word-limit="true" size="small"></el-input>
        </el-form-item>
        <el-form-item v-model="addingForm.childNo" :label="$titles.child+'编号'">
          <el-input v-model="addingForm.childNo" placeholder="选填" maxlength="30" :show-word-limit="true" size="small"></el-input>
          <div>建议只填写字母、数字、减号、下划线 等</div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button v-if="!showAddingForm" size="small" @click="childDialogVisible = false">取 消</el-button>
        <el-button v-if="!showAddingForm" v-preventReClick size="small" type="primary" @click="commitSelectChild()">确
          定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import folderService from "@/CommonDP/service/folder-service";
export default {
  props: {
    first: {
      type: Boolean,
      default: false
    },
    treeData: {
      type: Object,
      required: false,
      default: () => {}
    },
    data: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  data() {
    return {
      childDialogVisible: false,
      selectionData: [],
      childNameToAdd: '',
      childList: [],
      showAddingForm: false,
      addingForm: {
        childName: "",
        childNo: ""
      },
      tabKey: 1,
      searchValue: '',
      searchList: []
    };
  },
  computed: {
    ...mapState({
      prjInfo: (state) => state.projectMg.prjObj,
      enterpriseId: (state) => state.enterprise.enterpriseId
    }),
    filteredChildList() {
      // 过滤已添加的数据
      if (!this.childDialogVisible) return [];
      const existChildIds = this.treeData?.childrenList?.map(item => item.typeId) || [];
      const dataChildIds = this.data?.map(item => item.typeId) || [];
      return this.childList.filter((item) => {
        if (this.first) {
          return !dataChildIds.includes(item.childId);
        } else {
          return !existChildIds.includes(item.childId);
        }
      });
    }
  },
  watch: {
    searchValue(newValue) {
      if (!newValue) {
        this.searchList = this.filteredChildList;
      }
    }
  },
  methods: {
    show() {
      this.searchValue = "";
      this.searchList = [];
      this.childNameToAdd = '';
      this.selectionData = [];
      this.childList = [];
      this.childDialogVisible = true;
      this.tabKey++;
      this.queryChildList();
    },
    async queryChildList() {
      const prjId = this.prjInfo.prjId;
      const res = await folderService.queryChildList({ prjId });
      this.childList = res.data || [];
      this.search();
    },
    async handleDeleteChild(val) {
      this.$confirm("如果" + this.$titles.child + "已被使用，请不要删除，确认要删除选中的" + this.$titles.child + "吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        closeOnClickModal: false,
        closeOnPressEscape: false
      }).then(async () => {
        await folderService.dynamicChildDelete(val.id);
        const index = this.selectionData.findIndex(
          item => item.childId === val.childId
        );
        this.selectionData.splice(index, 1);
        this.$refs.multipleTable.toggleRowSelection(val, false);
        this.$message.success("删除成功");
        this.queryChildList();
      });
    },

    async handleAddChild() {
      const isValid = await this.$refs.addingForm.validate();
      if (!isValid) {
        return;
      }
      const childNo = this.filteredChildList.some(ele => ele.childNo === this.addingForm.childNo);
      if (childNo && this.addingForm.childNo) {
        this.$error(this.$titles.child + "编号已存在");
        return;
      }
      this.addingForm.enterpriseId = this.enterpriseId;
      this.addingForm.prjId = this.prjInfo.prjId;
      await folderService.addPrjChild(this.addingForm);
      this.$message.success("添加成功");
      await this.queryChildList();
      this.showAddingForm = false;
    },
    commitSelectChild() {
      if (!this.selectionData.length) {
        this.$warn("请勾选要添加的" + this.$titles.child);
        return;
      }
      const data = { type: "child", val: 3, selectionData: this.selectionData, parentNodeData: this.treeData };
      this.$emit("callback", data);
      this.childDialogVisible = false;
    },
    handleSelectionChange(val) {
      this.selectionData = val;
    },
    search() {
      const { searchValue: name } = this;
      setTimeout(() => {
        this.searchList = this.filteredChildList.filter((item) => this.filterKeyword(item, name));
      }, 500);
    },
    filterKeyword(item, name) {
      const keyArr = ["childName", "childNo"];
      let flag = false;
      while (keyArr[0] && !flag) {
        if (item[keyArr.shift()].includes(name)) flag = true;
      }
      return flag;
    },
    // 关闭事件
    close(){
      this.addingForm = {
        childName: "",
        childNo: ""
      };
      this.showAddingForm = false;
    }
  }
};
</script>

<style scoped lang="scss">
.addTitle {
  font-size: 1.1em;
  font-weight: bold;
}
</style>
